import { pageNotFoundComponent } from './page-not-found.component';
import './page-not-found.scss';

export const pageNotFound = angular
     .module('components.pageNotFound', [])
     .component('pageNotFound', pageNotFoundComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('PageNotFound', {
			url: '/page-not-found',
			component: 'pageNotFound',
			breadcrumbName: '404: Page Not Found',
			parentState: 'Home'
		});
     })
     .name;


// WEBPACK FOOTER //
// ./src/app/components/page-not-found/page-not-found.module.js